import React from 'react';
import {Trans, useTranslation} from 'react-i18next';
import LeftTitleWithField from '../../layout/LeftTitleWithField';
import {Field} from 'formik';
import _get from 'lodash/get';
import CustomSwitch from '../../../../../components/layout/CustomSwitch';
import Select from 'react-select';
import langUtils from '../../../../../utils/langUtils';
import SelectBox from '../../../../../components/formik/SelectBox';
import {scoreRanges} from '../../../../../utils/skincareUtils';
import TextareaBox from '../../../../../components/formik/TextareaBox';
import Section from '../../layout/Section';

export default function DetectionCard({
  formikProps,
  transformedCategories,
  defaultCardCategory,
}) {
  const {t} = useTranslation();
  return (
    <Section
      title={
        <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skin.detection.card">
          Skin Detection Card Description
        </Trans>
      }
    >
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.show.card.comment">
            Show Card Comment
          </Trans>
        }
      >
        <Field
          name="skinResultPage.skinReport.card.showComment"
          value={_get(formikProps.values, 'skinResultPage.skinReport.card.showComment')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      <LeftTitleWithField
        title={
          <Trans i18nKey="p.s.uiconfiguration.skinresultpage.show.card.description">
            Show Card Description
          </Trans>
        }
      >
        <Field
          name="skinResultPage.skinReport.card.showDescription"
          value={_get(formikProps.values, 'skinResultPage.skinReport.card.showDescription')}
          component={CustomSwitch}
        />
      </LeftTitleWithField>
      {_get(formikProps.values, 'skinResultPage.skinReport.card.showDescription') && (
        <>
          <LeftTitleWithField
            title={
              <Trans i18nKey="p.s.uiconfiguration.skinresultpage.select.editing.language">
                Select Editing Language
              </Trans>
            }
          >
            <Select
              options={langUtils.getAppLangList()}
              onChange={o => {
                formikProps.setFieldValue('skinResultPage.skinReport.card.language', o);
              }}
              value={_get(formikProps.values, 'skinResultPage.skinReport.card.language', {
                label: 'English',
                value: 'enu',
              })}
              isSearchable={false}
              isClearable={false}
              placeholder={
                <Trans i18nKey="c.c.select.placeholder">Select...</Trans>
              }
            />
          </LeftTitleWithField>
          <LeftTitleWithField
            title={
              <Trans i18nKey="p.s.uiconfiguration.skinresultpage.skin.concern">
                Skin Concern
              </Trans>
            }
          >
            <Field
              name="skinResultPage.skinReport.card.category"
              options={transformedCategories}
              isSearchable={true}
              component={SelectBox}
            />
          </LeftTitleWithField>
          {scoreRanges(2).map(range => (
            <div key={range.value}>
              <LeftTitleWithField title={range.label}>
                <Field
                  name={`skinResultPage.skinReport.card.description.${_get(
                    formikProps.values,
                    'skinResultPage.skinReport.card.language.value',
                    'enu'
                  )}.${_get(
                    formikProps.values,
                    'skinResultPage.skinReport.card.category',
                    defaultCardCategory
                  )}.${range.key}`}
                  component={TextareaBox}
                  maxlength="350"
                  style={{width: '100%'}}
                  placeholder={t('c.f.text.up.character', {
                    defaultValue: 'Up to {{maxNum}} characters recommended.',
                    maxNum: 350,
                  })}
                />
              </LeftTitleWithField>
            </div>
          ))}
        </>
      )}
    </Section>
  );
}
